import React from "react";
import { useSearchParams } from "react-router-dom";
import NewsletterTab from "../components/AdminCommunication/NewsletterTab";
import PushNotificationsTab from "../components/AdminCommunication/PushNotificationsTab";

const TABS = [
  { key: "newsletter", label: "Newsletter" },
  { key: "push", label: "Push Notifications" },
] as const;

const AdminCommunication: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const requested = searchParams.get("tab");
  const activeTab = TABS.find((t) => t.key === requested) ?? TABS[0];

  return (
    <div>
      <div className="flex flex-col gap-4 mb-6">
        <h2 className="font-medium">Campaigns</h2>
      </div>

      <div className="flex flex-wrap gap-1 mb-8 border-b border-gray-200">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setSearchParams({ tab: tab.key })}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
              tab.key === activeTab.key
                ? "border-primary text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab.key === "push" ? <PushNotificationsTab /> : <NewsletterTab />}
    </div>
  );
};

export default AdminCommunication;
